import { FC } from 'react';
import { AllieText } from '../../../../../components/Text';
import {
  AllieCoinsIcon,
  AllieCoinsHandsIcon,
  AllieCurrencyDollarCircleIcon,
} from '../../../../../styling/icons/Icons';
import { numberFormatWithCommas } from '../../../../../common/utils';
import type { GeneralCostMetricsProps } from './GeneralCostMetrics.types';
import {
  Container,
  MetricCard,
  IconContainer,
  TextContainer,
  ValueContainer,
} from './GeneralCostMetrics.styles';

export const GeneralCostMetrics: FC<GeneralCostMetricsProps> = ({
  data,
  labels,
  isEmpty = false,
}) => {
  const formatNumber = (number: number) => {
    return numberFormatWithCommas(number.toFixed(2));
  };

  const metrics = [
    {
      icon: <AllieCurrencyDollarCircleIcon display="contents" allieColor="neutral-50" />,
      label: labels.totalPlannedCost,
      value: `$${formatNumber(data.totalPlannedCost)}`,
    },
    {
      icon: <AllieCoinsIcon display="contents" allieColor="neutral-50" />,
      label: labels.totalActualCost,
      value: `$${formatNumber(data.actualCost)}`,
    },
    {
      icon: <AllieCoinsHandsIcon display="contents" allieColor="neutral-50" color="currentColor" />,
      label: data.difference > 0 ? labels.costExceeded : labels.costSaved,
      value: `$${formatNumber(Math.abs(data.difference))}` ,
    },
  ];

  return (
    <>
      <AllieText type="body1" weight={500}>
        {labels.title}
      </AllieText>
      <Container>
        {metrics.map((metric, index) => (
          <MetricCard key={index}>
            <IconContainer>{metric.icon}</IconContainer>
            <TextContainer>
              <AllieText type="body3" color="neutral-70">
                {metric.label}
              </AllieText>
              <ValueContainer>
                <AllieText type="h4" color="neutral-70">
                  {isEmpty ? labels.withoutData : metric.value}
                </AllieText>
              </ValueContainer>
            </TextContainer>
          </MetricCard>
        ))}
      </Container>
    </>
  );
};
